import { render, staticRenderFns } from "./WorkflowFormVersionBuilder.vue?vue&type=template&id=5bd43500"
import script from "./WorkflowFormVersionBuilder.vue?vue&type=script&lang=js"
export * from "./WorkflowFormVersionBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports